<button
  type="button"
  class="btn btn-secondary btn-block"
  [ngClass]="cssClass"
  (click)="openModal(modal)"
  [disabled]="displaySpinner()"
  data-testing-id="addOrderToOrderTemplateButton"
>
  @if (displaySpinner() !== true) {
  {{ 'order_template.create.heading' | translate }}
  } @else {
  <fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" ngClass="pr-3" />
  <span>{{ 'common.button.spinning.label' | translate }}</span>
  }
  <!-- spinning animation after clicking button -->
  &nbsp;
</button>

<ish-order-template-preferences-dialog
  #modal
  modalTitle="account.order_template.new_from_order.heading"
  (submitOrderTemplate)="createOrderTemplate($event)"
/>
